// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.znw51EB0mSDknERlkrMh {
  max-width: 90rem;
  max-height: calc(90vh - 5rem);
  height: auto;
  margin: 0 auto;
  background-color: var(--white);
  overflow-y: auto;
}

._3khG_UdAqZsk8JeOaNL2 {
  position: fixed;
  width: 100%;
  top: var(--offset);
  height: calc(100% - var(--offset));
  background-color: rgba(15, 10, 27, 0.72);
  z-index: 8;
}

.hxYM90stCqwvWy5qpztw {
  background-color: var(--yellow);
  height: 100vh
}

.hxYM90stCqwvWy5qpztw .iEOPxDO5vRbK8MDL5Dav {
    background-color: var(--bright-ruby);
    height: var(--background-offset);
  }

.hxYM90stCqwvWy5qpztw .MPQ3po4TR6SuKqFSYP8N {
    background-color: var(--purple);
    height: var(--background-offset);
  }

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .znw51EB0mSDknERlkrMh {
    height: 100%;
    max-height: unset;
  }
}

@media only screen and
  (max-width: 639px) {
  .znw51EB0mSDknERlkrMh {
    height: 100%;
    max-height: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DynamicalHeightFullScreenModalWindow/DynamicalHeightFullScreenModalWindow.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B;AAWF;;AATE;IACE,oCAAoC;IACpC,gCAAgC;EAClC;;AAEA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;;AAGF;;;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":[".dynamicalHeightFullScreenModalWindow {\n  max-width: 1440px;\n  max-height: calc(90vh - 80px);\n  height: auto;\n  margin: 0 auto;\n  background-color: var(--white);\n  overflow-y: auto;\n}\n\n.overlayClassName {\n  position: fixed;\n  width: 100%;\n  top: var(--offset);\n  height: calc(100% - var(--offset));\n  background-color: rgba(15, 10, 27, 0.72);\n  z-index: 8;\n}\n\n.dynamicalHeightModalEmulator {\n  background-color: var(--yellow);\n  height: 100vh;\n\n  & .brightRubyBackground {\n    background-color: var(--bright-ruby);\n    height: var(--background-offset);\n  }\n\n  & .purpleBackground {\n    background-color: var(--purple);\n    height: var(--background-offset);\n  }\n}\n\n@media (--tablet) {\n  .dynamicalHeightFullScreenModalWindow {\n    height: 100%;\n    max-height: unset;\n  }\n}\n\n@media (--mobile) {\n  .dynamicalHeightFullScreenModalWindow {\n    height: 100%;\n    max-height: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dynamicalHeightFullScreenModalWindow": `znw51EB0mSDknERlkrMh`,
	"overlayClassName": `_3khG_UdAqZsk8JeOaNL2`,
	"dynamicalHeightModalEmulator": `hxYM90stCqwvWy5qpztw`,
	"brightRubyBackground": `iEOPxDO5vRbK8MDL5Dav`,
	"purpleBackground": `MPQ3po4TR6SuKqFSYP8N`
};
export default ___CSS_LOADER_EXPORT___;
